import {BBox} from "geojson";
import {MapRef} from "react-map-gl";

export function syncMaps(...maps: MapRef[]) {
    // Create all the movement functions, because if they're created every time
    // they wouldn't be the same and couldn't be removed.
    let fns: Parameters<mapboxgl.Map["on"]>[1][] = [];
    maps.forEach((map, index) => {
        // When one map moves, we turn off the movement listeners
        // on all the maps, move it, then turn the listeners on again
        fns[index] = () => {
            off();

            const center = map.getCenter();
            const zoom = map.getZoom();
            const bearing = map.getBearing();
            const pitch = map.getPitch();

            const clones = maps.filter((_, i) => i !== index);
            clones.forEach((clone) => {
                clone.jumpTo({
                    center: center,
                    zoom: zoom,
                    bearing: bearing,
                    pitch: pitch,
                });
            });

            on();
        };
    });

    const on = () => {
        maps.forEach((map, index) => {
            map.on("move", fns[index] as () => void);
        });
    };

    const off = () => {
        maps.forEach((map, index) => {
            map.off("move", fns[index] as () => void);
        });
    };

    on();

    return () => {
        off();
        fns = [];
        maps = [];
    };
}

export const fitMapToBbox = (mapRef: MapRef, bbox: BBox, duration?: number) => {
    const [minLng, minLat, maxLng, maxLat] = bbox;
    mapRef.fitBounds(
        [
            [minLng, minLat],
            [maxLng, maxLat],
        ],
        {padding: 80, duration: duration ?? 1000},
    );
};
